import React from 'react';
import { ConcreteColumnDefinitionData } from '../column-definition.enum';

type QueueCellContextValue = {
    index: number;
    eventId: number;
    columnDefinitionValue: ConcreteColumnDefinitionData;
};

const QueueCellContext = React.createContext<QueueCellContextValue | undefined>(undefined);

export const QueueCellProvider: React.FC<React.PropsWithChildren<QueueCellContextValue>> = (
    props
): React.ReactElement => {
    const { children, ...otherProps } = props;
    return <QueueCellContext.Provider value={otherProps}>{children}</QueueCellContext.Provider>;
};

export const useQueueCell = (): QueueCellContextValue => {
    const contextValue = React.useContext(QueueCellContext);
    if (!contextValue) {
        throw new Error('Unexpectedly did not find value on QueueCellContext');
    }
    return contextValue;
};
